import ApolloClient from "apollo-client";
import { PrismicLink } from "apollo-link-prismic";
import {
  InMemoryCache,
  IntrospectionFragmentMatcher,
} from "apollo-cache-inmemory";
import fragmentTypes from "./fragmentTypes.json"; // You may have to update this path

const apiEndpoint = "https://proxenos.cdn.prismic.io/graphql"; // Update this with your repo id
const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: fragmentTypes,
});

export const client = new (ApolloClient.ApolloClient || ApolloClient)({
  link: PrismicLink({ uri: apiEndpoint }),
  cache: new InMemoryCache({ fragmentMatcher }),
  defaultOptions: {
    query: {
      fetchPolicy: "no-cache",
    },
  },
});

export const queryOptions = () => {
  return {};
};
